// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.experience-card {
  width: 100%;
  margin-bottom: 20px;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
}

.experience-card-logo-div {
  margin: 10px;
}

.experience-card-body-div {
  width: 100%;
}

.experience-card-header-div {
  display: flex;
  flex-direction: row;
}

.experience-card-logo {
  width: 70px;
}

.experience-card-title {
  font-family: "Google Sans Regular";
  margin-top: 10px;
  margin-bottom: 2px;
  margin-left: 0px;
  margin-right: 7px;
  text-align: left;
}

.experience-card-company {
  font-family: "Google Sans Regular";
  margin: 0;
  text-align: left;
}

.experience-card-duration {
  font-family: "Google Sans Regular";
  margin-top: 10px;
  margin-bottom: 2px;
  margin-left: 0px;
  margin-right: 0px;
  text-align: right;
  color: #8c8c8c;
}

.experience-card-heading-left {
  float: left;
  margin-left: 10px;
  margin-right: auto;
}

.experience-card-heading-right {
  float: right;
  margin-left: auto;
  margin-right: 10px;
}

.experience-card-location {
  font-family: "Google Sans Regular";
  margin: 0;
  text-align: right;
  color: #868e96;
}

.experience-card-description {
  margin-top: 5px;
  margin-left: 10px;
  text-align: justify;
  margin-right: 20px;
  font-family: "Google Sans Regular";
}

.experience-card-company > a {
  position: relative;
  color: #8c8c8c;
  text-decoration: none;
}

.experience-card-company > a:hover {
  color: #8c8c8c;
}

.experience-card-company > a:hover:before {
  visibility: visible;
  transform: scaleX(1);
}

.experience-card-company > a:before {
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  bottom: 0;
  left: 0;
  background-color: #8c8c8c;
  visibility: hidden;
  transform: scaleX(0);
  transition: all 0.3s ease-in-out 0s;
}

@media (max-width: 768px) {
  .experience-card {
    margin-bottom: 10px;
    flex-direction: column;
    text-align: center;
  }

  .experience-card-logo {
    width: 100px;
  }

  .experience-card-body-div {
  }

  .experience-card-heading-left {
    float: center;
    margin-left: auto;
    margin-right: auto;
  }

  .experience-card-heading-right {
    float: center;
    margin-left: auto;
    margin-right: auto;
  }

  .experience-card-title {
    text-align: center;
  }

  .experience-card-company {
    text-align: center;
  }

  .experience-card-duration {
    margin-top: 2px;
    text-align: center;
  }

  .experience-card-location {
    /* text-align: left; */
    text-align: center;
  }

  .experience-card-header-div {
    flex-direction: column;
  }

  .experience-card-description {
    margin-left: 14px;
    margin-right: 14px;
    text-align: justify;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/experienceCard/ExperienceCard.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EAEnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,SAAS;EACT,OAAO;EACP,yBAAyB;EACzB,kBAAkB;EAElB,oBAAoB;EAEpB,mCAAmC;AACrC;;AAEA;EACE;IACE,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;EACA;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;AACF","sourcesContent":[".experience-card {\n  width: 100%;\n  margin-bottom: 20px;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: row;\n}\n\n.experience-card-logo-div {\n  margin: 10px;\n}\n\n.experience-card-body-div {\n  width: 100%;\n}\n\n.experience-card-header-div {\n  display: flex;\n  flex-direction: row;\n}\n\n.experience-card-logo {\n  width: 70px;\n}\n\n.experience-card-title {\n  font-family: \"Google Sans Regular\";\n  margin-top: 10px;\n  margin-bottom: 2px;\n  margin-left: 0px;\n  margin-right: 7px;\n  text-align: left;\n}\n\n.experience-card-company {\n  font-family: \"Google Sans Regular\";\n  margin: 0;\n  text-align: left;\n}\n\n.experience-card-duration {\n  font-family: \"Google Sans Regular\";\n  margin-top: 10px;\n  margin-bottom: 2px;\n  margin-left: 0px;\n  margin-right: 0px;\n  text-align: right;\n  color: #8c8c8c;\n}\n\n.experience-card-heading-left {\n  float: left;\n  margin-left: 10px;\n  margin-right: auto;\n}\n\n.experience-card-heading-right {\n  float: right;\n  margin-left: auto;\n  margin-right: 10px;\n}\n\n.experience-card-location {\n  font-family: \"Google Sans Regular\";\n  margin: 0;\n  text-align: right;\n  color: #868e96;\n}\n\n.experience-card-description {\n  margin-top: 5px;\n  margin-left: 10px;\n  text-align: justify;\n  margin-right: 20px;\n  font-family: \"Google Sans Regular\";\n}\n\n.experience-card-company > a {\n  position: relative;\n  color: #8c8c8c;\n  text-decoration: none;\n}\n\n.experience-card-company > a:hover {\n  color: #8c8c8c;\n}\n\n.experience-card-company > a:hover:before {\n  visibility: visible;\n  -webkit-transform: scaleX(1);\n  transform: scaleX(1);\n}\n\n.experience-card-company > a:before {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  height: 1px;\n  bottom: 0;\n  left: 0;\n  background-color: #8c8c8c;\n  visibility: hidden;\n  -webkit-transform: scaleX(0);\n  transform: scaleX(0);\n  -webkit-transition: all 0.3s ease-in-out 0s;\n  transition: all 0.3s ease-in-out 0s;\n}\n\n@media (max-width: 768px) {\n  .experience-card {\n    margin-bottom: 10px;\n    flex-direction: column;\n    text-align: center;\n  }\n\n  .experience-card-logo {\n    width: 100px;\n  }\n\n  .experience-card-body-div {\n  }\n\n  .experience-card-heading-left {\n    float: center;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .experience-card-heading-right {\n    float: center;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .experience-card-title {\n    text-align: center;\n  }\n\n  .experience-card-company {\n    text-align: center;\n  }\n\n  .experience-card-duration {\n    margin-top: 2px;\n    text-align: center;\n  }\n\n  .experience-card-location {\n    /* text-align: left; */\n    text-align: center;\n  }\n\n  .experience-card-header-div {\n    flex-direction: column;\n  }\n\n  .experience-card-description {\n    margin-left: 14px;\n    margin-right: 14px;\n    text-align: justify;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
